<template>
  <div>
    <y-shelf title="基本信息">
      <span slot="right"></span>
      <div slot="content">
       <div class="avatar-box">
          <div class=img-box><img :src="user.avatar == ''?'/static/images/default.png':user.avatar"></div>
          <div class="r-box">
            <h3 style="margin-left: 13px;">修改头像</h3>
            <y-button text="上传头像" classStyle="main-btn" style="margin: 0;" @btnClick="editAvatar()"></y-button>
          </div>
        </div>
        <div style="margin: 30px 30px 30px 40px;" >
          <el-row :gutter="30" style="margin-bottom: 10px;">
            <el-col :span="12">
              <label for="contact" style="letter-spacing:1.3px">联系人姓名</label><span>：</span>
              &nbsp;<input type="text" class="form-control" :value="user.contact" disabled="disabled">
            </el-col>{{user.nickname}}
            <el-col :span="12">
              <label v-if="user.userType=='10'" for="nickname" style="letter-spacing:3.01px">工厂/诊所：</label>
              <label v-if="user.userType=='20'" for="nickname" class="four">所属地区：</label>
              <input type="text" v-if="user.userType=='10'" class="form-control" :value="user.nickName" disabled="disabled">
              <input type="text" v-if="user.userType=='20'" class="form-control" :value="user.location" disabled="disabled">
              <label v-if="user.userType=='99'" for="location" class="four">所属地区：</label>
              <input type="text" v-if="user.userType=='99'" class="form-control" value="未知" disabled="disabled">
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-bottom: 10px;">
            <el-col :span="12">
              <label for="mobile" class="four">联系方式：</label>
              <input type="text" class="form-control" :value="user.mobile" disabled="disabled">
            </el-col>
            <el-col :span="12">
              <label for="loginDate" class="four">注册时间：</label>
              <input type="text" class="form-control" :value="user.createTime" disabled="disabled">
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-bottom: 20px;">
          <el-col :span="12" v-if="user.userType=='10'">
            <label for="" class="four">所属地区：</label>
            <input type="text" class="form-control" :value="user.location" disabled="disabled">
          </el-col>
          <el-col :span="12">
            <label for="" class="four">{{user.userType=='20'?'总接单数':'发单次数'}}：</label>
            <input type="text" class="form-control" :value="(user.demServType!='99'?user.demTotalCount:user.desTotalCount)+'单'" disabled="disabled">
          </el-col>
          <el-col :span="12">
            <label for="" class="four">完成订单：</label>
            <input type="text" class="form-control" :value="(user.demServType!='99'?user.demFinishCount:user.desFinishCount)+'单'" disabled="disabled">
          </el-col>
          <el-col :span="12" v-show="user.userType=='20'">
            <label for="" class="four">服务等级：</label>
            <input type="text" class="form-control" :value="desLevel" disabled="disabled">
          </el-col>
          <el-col :span="12" v-show="user.userType=='20'">
            <label for="" class="three">服务值：</label>
            <input type="text" class="form-control" :value="user.desFinishCount+(user.desFinishCount<1000?'/1000':'/5000')" disabled="disabled" style="margin-left: -5px;">
          </el-col>
          <el-col :span="12" v-show="user.userType=='10'">
            <label for="" class="three">总支出：</label>
            <input type="text" class="form-control" :value="user.demTotalAmount+'元'" disabled="disabled" style="margin-left: -5px;">
          </el-col>
		  </el-row>
        </div>
        <div class="edit-avatar" v-if="editAvatarShow">
          <y-shelf title="设置头像">
            <span slot="right">
              <span class="close" @click="editAvatarShow=false">
                <svg t="1501234940517" class="icon" style="" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="3014" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
                  height="20">
                  <path
                    d="M941.576 184.248l-101.824-101.824L512 410.176 184.248 82.424 82.424 184.248 410.168 512l-327.744 327.752 101.824 101.824L512 613.824l327.752 327.752 101.824-101.824L613.832 512z"
                    fill="#cdcdcd" p-id="3015"></path>
                </svg>
              </span>
            </span>
            <div slot="content" class="content">
              <div class="edit-l">
                <div style="width: 100px;height: 100px;border: 1px solid #ccc;margin-bottom: 20px;overflow: hidden;background-color: black;">
                  <div class="show-preview"
                    :style="{'width': previews.w + 'px','height': previews.h + 'px','overflow': 'hidden','zoom':option.zoom}">
                    <div :style="previews.div">
                      <img :src="option.img" :style="previews.img">
                    </div>
                  </div>
                </div>
                <div style="padding: 10px 0 ">头像预览</div>
                <div class="btn">
                  <a href="javascript:;">重新选择</a>
                  <input type="file" value="上传头像" @change="upimg($event)">
                </div>
              </div>
              <div class="edit-r">
                <div>
                  <div class="big" id="cropper-target" v-if="option.img">
                    <vueCropper :img="option.img" @realTime="realTime" ref="cropper" :outputSize="example2.size"
                      :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
                      :autoCropWidth="example2.width" :autoCropHeight="example2.height" :fixed="example2.fixed">
                    </vueCropper>
                  </div>
                </div>
              </div>
              <div class="bootom-btn pa">
                <y-button style="width: 140px;height: 40px;line-height: 40px" text="取消"
                  @btnClick="editAvatarShow=false">
                </y-button>
                <y-button style="width: 140px;height: 40px;line-height: 40px" text="确定" classStyle="main-btn"
                  @btnClick="cropper">
                </y-button>
              </div>
            </div>
          </y-shelf>
        </div>
      </div>
    </y-shelf>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import YShelf from '/components/YShelf'
  import vueCropper from 'vue-cropper'
  import {
    mapState
  } from 'vuex'
  import {
    getStore
  } from '/utils/storage'
import user from '../../../store/modules/user'
  export default {
    data() {
      return {
        percentage:parseInt(800/5001*100),
        editAvatarShow: false,
        cropContext: '',
        cropperImg: '',
        previews: {},
        option: {
          img: '',
          zoom: 0
        },
        fixedNumber: [1, 1],
        example2: {
          info: true,
          size: 1,
          canScale: false,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 300,
          autoCropHeight: 250,
          // 开启宽度和高度比例
          fixed: true
        },
        userId: '',
        token: '',
        desLevel:'',
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      upimg(e) {
        var file = e.target.files[0]
        if (file.size > 1048576) {
          this.$yxz.msg('图片大小不得超过1Mb')
          return false
        }
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
          this.$yxz.msg('图片类型仅支持.gif,jpeg,jpg,png,bmp')
          return false
        }
        var reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.option.img = e.target.result
        }
      },
      cropper() {
        this.$yxz.msg('上传中...','info')
        if (this.option.img) {
          this.$refs.cropper.getCropData((data) => {
            this.$api.post({
              url: '/user/uploadAvatar',
              data: {
                avatarStr: data
              },
              isToken: true
            }).then(res => {
              if (res.code === 200) {
                this.$store.commit('user/setUserInfo', {
                  avatar: res.avatarUrl
                })
                this.editAvatarShow = false
                this.$yxz.msg("上传成功", 'success')
                location.reload();
              } else {
                this.$yxz.msg(res.message)
              }
            })
          })
        } else {
          this.$yxz.msg('请先选择照片')
        }
      },
      base64ImgtoFile(dataurl, filename = "file") {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const suffix = mime.split("/")[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime,
        });
      },
      editAvatar() {
        this.editAvatarShow = true
      },
      realTime(data) {
        this.previews = data
        let w = 100 / data.w
        this.option.zoom = w
      },
	  format(percentage) {
	          return percentage === 100 ? '满' : `${percentage}%`;
	        },
    },
    created() {
      switch(this.user.desLevel){
        case '01':
        this.desLevel = '初级设计师'
        break;
        case '02':
        this.desLevel = '中级设计师'
        break;
        case '03':
        this.desLevel = '高级设计师'
        break;
        case '99':
        this.desLevel = '认证级设计师'
        break;
      }
    },
    components: {
      YButton,
      YShelf,
      vueCropper,
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../../assets/style/mixin";
  .avatar-box {
    height: 124px;
    display: flex;
    margin: 0 30px 30px;
    border-bottom: #dadada solid 1px;
    line-height: 30px;
    display: flex;
    align-items: center;

    .img-box {
      @include wh(80px);
      border-radius: 5px;
      overflow: hidden;
    }

    img {
      display: block;
      @include wh(100%)
    }

    .r-box {
      margin-left: 20px;

      h3 {
        font-size: 18px;
        font-weight: 400;
        color: #333;
      }
    }
  }

  // 修改头像
  .edit-avatar {
    z-index: 9999;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    @include wh(100%);
    background-color: rgba(0, 0, 0, .5);
    @extend %block-center;

    .content {
      display: flex;
      padding: 45px 100px 0;
    }

    >div {
      box-sizing: content-box;
      @include wh(700px, 500px);
      margin: 0;
    }

    .btn {
      width: 80px;
      height: 30px;
      margin-left: 10px;
      position: relative;
      text-align: center;
      line-height: 30px;
      text-shadow: rgba(255, 255, 255, .496094) 0 1px 0;
      border: 1px solid #E6E6E6;
      border-radius: 10px;

      &:hover {}

      a {
        color: #666;
        display: block;
        @include wh(100%);
      }
    }

    input[type=file] {
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      opacity: 0;
      width: 80px;
      height: 30px;
      cursor: pointer;
      box-sizing: border-box;
      border: 15px solid #000;
      overflow: hidden;
    }

    .edit-l {
      width: 100px;
      text-align: center;
    }

    .edit-r {
      margin-left: 20px;
      flex: 1;
      >div {
        border: 1px solid #ccc;
        width: 320px;
        height: 320px;
		background-color: #000;
      }
    }
  }

  .image-container {
    width: 100px;
    height: 100px;
    border: 1px solid #ccc;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    padding: 0 10px;
    @extend %block-center;

    &:hover {
      svg {
        transition: all 1s;
        transform: rotate(360deg);
        transform-origin: 50% 50%;
      }

      path {
        fill: #8a8a8a;
      }
    }
  }

  .big {
    display: block;
    width: 320px;
    height: 320px;
  }

  .bootom-btn {
    padding: 0 15px;
    border-top: 1px solid #E6E6E6;
    bottom: 0;
    height: 60px;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  label {
      display: inline-block;
      font-family: Lato, sans-serif;
      margin-bottom: 5px;
      vertical-align: middle;
  }
  .form-control {
      border: .0625rem solid #e7eaf3;
  }
  .form-control {
    // display: block;
    width: 100%;
    height: 38px;
	border-radius: 5px;
	padding: 0 12px;
  }
  input[type="text"] {
      border: 0;
      border-radius: 5px;
      font-family: Lato,sans-serif;
      line-height: 36px;
      margin-bottom: 20px;
      padding: 0 12px;
      transition: border-color cubic-bezier(0.77,0,0.175,1);
      width: 65%;
	  border: 1px solid #e8e8e8;
	  display: inline;
  }
  input:disabled {
      cursor: default;
      background-color: -internal-light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
      color: -internal-light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
  }
  .demo-progress .el-progress--line {
    margin-bottom: 15px;
    width: 100%;
  }
  .three{
	  letter-spacing:11px
  }
  .four{
  	  letter-spacing:5px
  }
  #Connector{
	  margin: 0 30px 0 30px;
	  font-size: 1px;
  }
  .picture{
	  margin-left: 50%;
	  margin-top: -23%;
  }
</style>



// WEBPACK FOOTER //
// information.vue?c093578e